import React from "react";
import style from "./QuestionHeader.module.scss";
import Filter from "../Filter/index";

export default function QuestionHeader({
    count,
    onSelect
}: {
    count: number;
    onSelect: (value: string) => void;
}) {
    return (
        <div className={style.root}>
            <h1 className={style.title}>学生提问</h1>

            <Filter count={count} onSelect={onSelect} />
        </div>
    );
}
